// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__17XZ6","col":"styles_col__1zOYN"};